import styled from 'styled-components';
import { DragPosition } from './types';

export const DragHandle = styled.span`
    opacity: 0;
    transition: opacity 0.2s ease;
    display: flex;
    align-items: center;
`;

export const StyledListItem = styled.li<{
    $isDragging: boolean;
    $dropPosition: DragPosition;
}>`
    cursor: grab;
    list-style: none;
    padding: 4px 8px;
    opacity: ${({ $isDragging }) => ($isDragging ? 0.5 : 1)};
    background-color: ${({ $isDragging }) => ($isDragging ? 'var(--gray-2)' : 'transparent')};
    color: ${({ $isDragging }) => ($isDragging ? 'var(--gray-6)' : 'inherit')};

    &:hover ${DragHandle} {
        opacity: 1;
    }

    &:not(:last-child) {
        border-bottom: ${({ $dropPosition }) =>
            $dropPosition === 'bottom' ? '2px dashed var(--brand-5)' : '1px solid var(--gray-4)'};
    }

    &:last-child {
        border-bottom: ${({ $dropPosition }) => ($dropPosition === 'bottom' ? '2px dashed var(--brand-5)' : 'none')};
    }

    border-top: ${({ $dropPosition }) => ($dropPosition === 'top' ? '2px dashed var(--brand-5)' : 'none')};
`;
